import { render, staticRenderFns } from "./NovoTime.vue?vue&type=template&id=17419183&scoped=true"
import script from "./NovoTime.vue?vue&type=script&lang=js"
export * from "./NovoTime.vue?vue&type=script&lang=js"
import style0 from "./NovoTime.vue?vue&type=style&index=0&id=17419183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17419183",
  null
  
)

export default component.exports